/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../ISymbolData';
import StreakTrackerRuleBase from './StreakTrackerRuleBase';

/** Rule for dertmining stacks of symbols. */
@cc._decorator.ccclass
export default class StackSymbolCountRule extends StreakTrackerRuleBase
{
    /** Filters only those with symbols that have same symbol on top and / or bottom. */
    protected applyRuleFilter(): ISymbolData[]
    {
        let reelToSymbolOffsetMap: Map<number, Map<number, ISymbolData>> = new Map();
        let filteredSymbols: ISymbolData[] = [];

        // Create Map of reelIndex -> Map of Offset -> SymbolData
        for (let symbol of this.validSymbols)
        {
            let symbolOffsetMap: Map<number, ISymbolData> = reelToSymbolOffsetMap.get(symbol.ReelIndex);
            if (!symbolOffsetMap)
            {
                symbolOffsetMap = new Map<number, ISymbolData>();
                reelToSymbolOffsetMap.set(symbol.ReelIndex, symbolOffsetMap);
            }

            symbolOffsetMap.set(symbol.OffSet, symbol);
        }

        // Discover if top or bottom neighbor using new map.
        for (let symbol of this.validSymbols)
        {
            if (filteredSymbols.indexOf(symbol) > -1) { continue; }

            let offsetMap: Map<number, ISymbolData> = reelToSymbolOffsetMap.get(symbol.ReelIndex);
            if (offsetMap)
            {
                let onTop: ISymbolData = offsetMap.get(symbol.OffSet + 1);
                let onBottom: ISymbolData = offsetMap.get(symbol.OffSet - 1);

                if (!onTop && !onBottom) { continue; }

                filteredSymbols.push(symbol);
            }
        }

        return filteredSymbols;
    }
}
